// extracted by mini-css-extract-plugin
export var alignLeft = "y_p5 d_fl d_bC d_dr";
export var alignCenter = "y_bL d_fm d_bz d_ds";
export var alignRight = "y_p6 d_fn d_bD d_dt";
export var comparisonComponentContentEqual = "y_h7 d_h7 d_bY d_s d_bw d_bB d_bF d_s";
export var comparisonComponentEqual = "y_h9 d_h9 d_s d_v d_cT";
export var positioner = "y_sW";
export var wrapper = "y_sX d_c5";